/* eslint-disable jsx-a11y/alt-text */
import PropTypes from 'prop-types';

import Image from 'components/Image';

import APP from 'constants/app';

const CarouselItem = ({ alt, darkImageName, imageName, lightImageName }) => {
  const commonProps = {
    alt,
    height: 96,
    width: 147,
  };

  if (!darkImageName) {
    return (
      <Image
        className="brightness-[.15] dark:brightness-150"
        src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/partners/${imageName}`}
        {...commonProps}
      />
    );
  }

  return (
    <>
      <Image
        className="hidden dark:block"
        src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/partners/${darkImageName}`}
        {...commonProps}
      />
      <Image
        className="dark:hidden"
        src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/partners/${lightImageName}`}
        {...commonProps}
      />
    </>
  );
};

CarouselItem.propTypes = {
  alt: PropTypes.string.isRequired,
  darkImageName: PropTypes.string,
  imageName: PropTypes.string,
  lightImageName: PropTypes.string,
};

export default CarouselItem;
